module.exports = __webpack_public_path__ + "img/sequins.af42af53.jpg";